// extracted by mini-css-extract-plugin
module.exports = {"root":"k_b","dividerAnimation":"k_p"};